/*
 * @Desc: 路由入口
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-12 11:21:50
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import Vue from 'vue';
import Router from 'vue-router';
// import store from '.././vuex/store'
import routers from './routers';

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: routers
});

/**
 * role 0 为普通用户，目前没有其他角色；
 * keepAlive 为是否缓存页面，默认为false 不缓存
 */

// 导航钩子，全局钩子
router.beforeEach((to, from, next) => {
  // 登录页面
  // console.log(from)
  if (to.meta.title) {
    window.document.title = to.meta.title;
  }
  next();
});
router.afterEach(to => { });

export default router;
